import axios from "axios";

export default axios.create({
    baseURL:"https://wns-sentry.sony.eu/tne/tneapi/v1",
    headers: {
        'Content-Type': 'application/json'
      }
});